export default __webpack_public_path__ + "static/media/icon-airplane.facaec69.svg";